export default "__VITE_ASSET__DFD$dwq1__"